import Snap from 'snapsvg-cjs';

const sectionNav = () => {
  const s = Snap('.js-nav-trigger');
  const top = s.line(1, 3, 24, 3).attr({
    strokeWidth: 3,
    stroke: '#9D7CFF',
  });
  const center = s.line(1, 8, 24, 8).attr({
    strokeWidth: 3,
    stroke: '#9D7CFF',
  });
  const bottom = s.line(1, 13, 24, 13).attr({
    strokeWidth: 3,
    stroke: '#9D7CFF',
  });
  document.querySelector('.js-nav-trigger').addEventListener('click', e => {
    document.querySelector('.js-nav-trigger').classList.toggle('is-active');
    document.querySelector('.js-header-nav').classList.toggle('is-active');
    if (
      document.querySelector('.js-nav-trigger').classList.contains('is-active')
    ) {
      top.animate(
        {
          x1: 7,
          x2: 18,
          y2: 13,
          stroke: '#FF0050',
        },
        300,
      );
      center.animate(
        {
          x1: 24,
        },
        300,
      );
      setTimeout(() => {
        center.attr({
          x1: 1,
          x2: 1,
        });
      }, 400);
      bottom.animate(
        {
          x1: 7,
          x2: 18,
          y2: 3,
          stroke: '#FF0050',
        },
        300,
      );
    } else {
      top.animate(
        {
          x1: 1,
          x2: 24,
          y2: 3,
          stroke: '#9D7CFF',
        },
        300,
      );
      center.animate(
        {
          x2: 24,
        },
        300,
      );
      bottom.animate(
        {
          x1: 1,
          x2: 24,
          y2: 13,
          stroke: '#9D7CFF',
        },
        300,
      );
    }
  });
};

export default sectionNav;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-nav.js